/**
 * Created by noOne on 28/02/2018.
 */

/**
 * Collision testing with rotation, also returns overlap in an object if a collision occurs, should be able to
 * use it to reverse the vector then move the colliding object along that vector by that distance, and the
 * sprite will be pushed out of whatever it collided with.
 * Original source - https://gist.github.com/louisstow/807250 - added fixes and adapted to PIXI
 * @param poly1
 * @param poly2
 * @returns {*}
 */
export default function SAT(poly1, poly2) {
    var points1 = convertVertsToVectors(poly1.vertexData),
        points2 = convertVertsToVectors(poly2.vertexData),
        i = 0, l = points1.length,
        j, k = points2.length,
        normal = {x: 0, y: 0},
        length,
        min1, min2,
        max1, max2,
        interval,
        MTV,
        dot,
        nextPoint,
        currentPoint;

    //loop through the edges of Polygon 1
    for (; i < l; i++) {
        nextPoint = points1[(i == l - 1 ? 0 : i + 1)];
        currentPoint = points1[i];

        //generate the normal for the current edge
        normal.x = -(nextPoint[1] - currentPoint[1]);
        normal.y = (nextPoint[0] - currentPoint[0]);

        //normalize the vector
        length = Math.sqrt(normal.x * normal.x + normal.y * normal.y);
        normal.x /= length;
        normal.y /= length;

        //default min max
        min1 = min2 = -1;
        max1 = max2 = -1;

        //project all vertices from poly1 onto axis
        for (j = 0; j < l; ++j) {
            dot = points1[j][0] * normal.x + points1[j][1] * normal.y;
            if (dot > max1 || max1 === -1) max1 = dot;
            if (dot < min1 || min1 === -1) min1 = dot;
        }

        //project all vertices from poly2 onto axis
        for (j = 0; j < k; ++j) {
            dot = points2[j][0] * normal.x + points2[j][1] * normal.y;
            if (dot > max2 || max2 === -1) max2 = dot;
            if (dot < min2 || min2 === -1) min2 = dot;
        }

        //calculate the minimum translation vector should be negative
        interval = (min1 < min2) ? min2 - max1 : min1 - max2;

        //exit early if positive
        if (interval > 0) {
            return false;
        }
        if (interval > MTV) MTV = interval;
    }

    //loop through the edges of Polygon 1
    for (i = 0; i < k; i++) {
        nextPoint = points2[(i == k - 1 ? 0 : i + 1)];
        currentPoint = points2[i];

        //generate the normal for the current edge
        normal.x = -(nextPoint[1] - currentPoint[1]);
        normal.y = (nextPoint[0] - currentPoint[0]);

        //normalize the vector
        length = Math.sqrt(normal.x * normal.x + normal.y * normal.y);
        normal.x /= length;
        normal.y /= length;

        //default min max
        min1 = min2 = -1;
        max1 = max2 = -1;

        //project all vertices from poly1 onto axis
        for (j = 0; j < l; ++j) {
            dot = points1[j][0] * normal.x + points1[j][1] * normal.y;
            if (dot > max1 || max1 === -1) max1 = dot;
            if (dot < min1 || min1 === -1) min1 = dot;
        }

        //project all vertices from poly2 onto axis
        for (j = 0; j < k; ++j) {
            dot = points2[j][0] * normal.x + points2[j][1] * normal.y;
            if (dot > max2 || max2 === -1) max2 = dot;
            if (dot < min2 || min2 === -1) min2 = dot;
        }

        //calculate the minimum translation vector should be negative
        interval = (min1 < min2) ? min2 - max1 : min1 - max2;

        //exit early if positive
        if (interval > 0) {
            return false;
        }
        if (interval > MTV) MTV = interval;
    }

    return {overlap: MTV};
}

function convertVertsToVectors(verts) {
    let arr = Common.matrix(4, 2);

    let count = 0;
    for (let i = 0; i < verts.length; i += 2) {
        arr[count][0] = verts[i];
        arr[count][1] = verts[i + 1];
        count++;
    }

    //  console.log(arr);

    return arr;
}